import {
  SET_DAO_HO,
  SHOW_FORM_DAO_HO,
  POST_DAO_HO,
  POST_DAO_HO_SUCCESS,
  POST_DAO_HO_FAILURE,
  GET_CONFIG_SYS_DAO_HO,
  SET_CONFIG_DAO_HO,
} from "actions/TraGop/DaoHo/actionTypes";
import { convertToNumber } from "utils/numberExtension";

const initialState = {
  daoHo: {
    NgayVay: new Date(),
    CustomerId: 0,
    IsEditChoVay: true,
    IsEditCustomer: true,
    IsDuNoGiamDan: false,
    ValueLai: 0,
    TienThuHangKy: 0,
    StatusPaidHo: 1,
  },
  ConfigDaoHo: {},
  isShowFormDaoHo: false,
  postDaoHoLoading: false,
  TaiSanDaoHo: {},
};
const setDaoHo = (state, action) => {
  let { ConfigDaoHo } = state;
  let { _laiDaoHo } = ConfigDaoHo;
  let daoHo = { ...action.payload };
  let { StatusPaidHo, Sotienvay, ValueLai, BocTrongVong, CountTypePaid } =
    daoHo;
  let tienVay = convertToNumber(Sotienvay);
  let tienLai = convertToNumber(ValueLai);
  daoHo.TienCatTruoc = tienVay - tienLai;
  daoHo.LaiTraGop = 0;
  let bocTrongVong = convertToNumber(BocTrongVong);
  let countTypePaid = convertToNumber(CountTypePaid);

  if (StatusPaidHo === 1) {
    daoHo.TienDuaKhach = tienLai;
    daoHo.TienThuHangKy = (tienVay * countTypePaid) / bocTrongVong;
    daoHo.TienCatTruoc = tienVay - tienLai;
  } else {
    daoHo.TienDuaKhach = tienVay;
    daoHo.TienThuHangKy = ((tienVay + tienLai) * countTypePaid) / bocTrongVong;
    if (_laiDaoHo === 2) {
      daoHo.TitleValueLai = "VD: cho vay 10tr, tổng thu 1 kỳ 3tr thì điền 3tr";
    } else if (_laiDaoHo === 1) {
      daoHo.TitleValueLai = "VD: cho vay 10tr, lãi 1 kỳ 3tr thì điền 3tr";
      daoHo.TienThuHangKy = (tienVay * countTypePaid) / bocTrongVong + tienLai;
    } else {
      daoHo.TitleValueLai = "VD: cho vay 10tr, lãi 3tr thì điền 3tr";
    }
  }
  return {
    ...state,
    daoHo,
  };
};

const showFormDaoHo = (state, action) => {
  let choVay = {
    NgayVay: new Date(),
    NgayThanhToan: new Date(),
    CustomerId: 0,
    StatusPaidHo: 1,
    TypePaid: 1,
    LaiDaoHo: 0,
  };
  if (action.payload && action.payload.ChoVayId) {
    choVay = { ...action.payload };
  }
  choVay.NgayThanhToan = new Date();
  // choVay.Sotienvay = '';
  // choVay.ValueLai = "";
  choVay.IsEditChoVay = true;
  choVay.IsEditCustomer = true;
  choVay.ChiPhiVay = choVay.ChiPhiVay
    ? parseFloat(choVay.ChiPhiVay.toFixed(2))
    : 0;
  return {
    ...state,
    daoHo: choVay,
    isShowFormDaoHo: !state.isShowFormDaoHo,
  };
};

const postDaoHo = (state, action) => ({
  ...state,
  postDaoHoLoading: true,
  dataPost: action.dataPost,
});

const postDaoHoSuccess = (state, action) => {
  let daoHo = { ...state.daoHo };
  daoHo.ChoVayId = action.payload.ChoVayId;
  daoHo.showButtonIn = true;
  daoHo.ThuChiId = action.payload.ThuChiId;
  if (parseFloat(daoHo.BeforeAfter) === 2) {
    daoHo.showButtonInPhieuThu = true;
  }
  return {
    ...state,
    postDaoHoLoading: false,
    daoHo,
  };
};

const postDaoHoFailed = (state, action) => ({
  ...state,
  postDaoHoLoading: false,
});

const getConfigSysDaoHo = (state, action) => ({
  ...state,
});

const setConfigDaoHo = (state, action) => {
  let config = action.payload;
  let daoHo = { ...state.daoHo };
  let {
    _laiTraGop,
    _kyGopTraGop,
    _khoangThoiGianTraGop,
    _beforeAfterTraGop,
    _duNoGiamDanTraGop,
    _traThieuTraDu,
  } = config;
  if (!daoHo.ChoVayId) {
    daoHo.TypePaid = parseInt(_kyGopTraGop) === 1 ? 1 : 2;
    daoHo.CountTypePaid = parseInt(_khoangThoiGianTraGop)
      ? _khoangThoiGianTraGop
      : "";
    daoHo.BeforeAfter = _beforeAfterTraGop === "1" ? 1 : 2;
    daoHo.IsDuNoGiamDan = _duNoGiamDanTraGop;
    daoHo.StatusPaidHo = _traThieuTraDu === 1 ? 1 : 2;
  }
  daoHo.TienCatTruoc = "";

  daoHo.LaiTraGop = _laiTraGop;
  if (daoHo.ChoVayId) {
    let { StatusPaidHo, Sotienvay, ValueLai, BocTrongVong, CountTypePaid } =
      daoHo;
    let bocTrongVong = convertToNumber(BocTrongVong);
    let countTypePaid = convertToNumber(CountTypePaid);
    let tienVay = convertToNumber(Sotienvay + "");
    daoHo.IsDuNoGiamDan = StatusPaidHo === 3;
    if (StatusPaidHo === 1) {
      let tienLai = Math.ceil(daoHo.ValueLai * daoHo.CountTypePaid);
      daoHo.ValueLai = tienVay - tienLai;
      daoHo.TienCatTruoc = tienVay - daoHo.ValueLai;
      daoHo.TienDuaKhach = daoHo.ValueLai;
      daoHo.TienThuHangKy = (tienVay * countTypePaid) / bocTrongVong;
    } else {
      daoHo.TienDuaKhach = tienVay;
      if (_laiTraGop === 2) {
        daoHo.TitleValueLai =
          "VD: cho vay 10tr, tổng thu 1 kỳ 3tr thì điền 3tr";
        // daoHo.ValueLai = daoHo.ValueLai * CountTypePaid;
        daoHo.ValueLai = Math.ceil(
          daoHo.ValueLai * CountTypePaid + daoHo.ValueGoc
        ); //Thêm phần này và sửa phần trên để thêm trường ValueLai 05/06
        let tienLai = Math.ceil(convertToNumber(ValueLai * CountTypePaid + ""));
        daoHo.TienThuHangKy =
          ((tienVay + tienLai) * countTypePaid) / bocTrongVong;
      } else if (_laiTraGop === 1) {
        daoHo.TitleValueLai = "VD: cho vay 10tr, lãi 1 kỳ 3tr thì điền 3tr";
        daoHo.ValueLai = Math.ceil(daoHo.ValueLai * daoHo.CountTypePaid);
        let tienLai = Math.ceil(convertToNumber(daoHo.ValueLai + ""));
        daoHo.TienThuHangKy =
          (tienVay * countTypePaid) / bocTrongVong + tienLai;
      } else {
        daoHo.TitleValueLai = "VD: cho vay 10tr, lãi 3tr thì điền 3tr";
        daoHo.ValueLai = Math.ceil(daoHo.ValueLai * daoHo.BocTrongVong);
        let tienLai = Math.ceil(convertToNumber(ValueLai * CountTypePaid + ""));
        daoHo.TienThuHangKy =
          ((tienVay + tienLai) * countTypePaid) / bocTrongVong;
      }
    }
  }
  return {
    ...state,
    daoHo,
    ConfigDaoHo: action.payload,
  };
};
const themMoiDaoHoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DAO_HO:
      return setDaoHo(state, action);
    case SHOW_FORM_DAO_HO:
      return showFormDaoHo(state, action);
    case POST_DAO_HO:
      return postDaoHo(state, action);
    case POST_DAO_HO_SUCCESS:
      return postDaoHoSuccess(state, action);
    case POST_DAO_HO_FAILURE:
      return postDaoHoFailed(state, action);
    case GET_CONFIG_SYS_DAO_HO:
      return getConfigSysDaoHo(state, action);
    case SET_CONFIG_DAO_HO:
      return setConfigDaoHo(state, action);
    default:
      return state;
  }
};
export default themMoiDaoHoReducer;
